__turbopack_context__.v({
  "dark": "kWZPAa_dark",
  "link": "kWZPAa_link",
});
